import React, { useEffect, useState, useRef } from "react"
import moment from "moment"
import Button from "components/Button"
import InputField from "components/InputField"
import PrintTestResults from "./PrintTestResults"
import fileUtils from "fileUtils"
import Toast from "../../../Toast"
import Print from "components/Print/Print"

function TestResults({ readOnly, response, handleSaveTestResults, patientInfo, smartSummaryData, appointmentDate }: any) {
  const componentRef = useRef(null)
  const tableRef: any = useRef(null)
  const vitalNames: any = {
    height: "Height",
    weight: "Weight",
    bsa: "BSA",
    bmi: "BMI",
    temperature: "Temperature",
    bpSystolic: "BP Systolic",
    bpDiastolic: "BP Diastolic",
    pulseInfo: "Pulse",
    spo2: "SPO2",
    hemoglobin: "Haemoglobin",
    wbcCount: "Total WBC Count",
    plateletsCount: "Platelets Count",
    anc: "Absolute Neutrophil Count (ANC)",
    totalBilirubinDirect: "Total Bilirubin",
    serumBilirubinDirect: "Serum Bilirubin Direct",
    serumBilirubinInDirect: "Serum Bilirubin Indirect",
    sgot: "SGOT (AST)",
    sgpt: "ALT (SGPT)",
    totalProtein: "Total Protein",
    sAlbumin: "Albumin",
    globulin: "Globulin",
    agRatio: "AG Ratio",
    alkalinePhosphate: "Alkaline Phosphatase",
    ggt: "GGT",
    serumCreatinine: "Serum Creatinine",
    bun: "BUN",
    urea: "Urea",
    uricAcid: "Uric Acid",
    sodium: "Sodium",
    potassium: "Potassium",
    chloride: "Chloride",
    sCalcium: "S.Calcium",
    ldh: "LDH",
    egfr: "eGFR- Creat Clearance",
    hgt: "HGT-mg/dl",
  }
  const [topRowHeaders, setTopRowHeaders] = useState<any>([])
  const [topRowDates, setTopRowDates] = useState<any>([])
  const [bottomRowHeadersMap, setBottomRowHeadersMap] = useState<any>({})
  const [reportUrls, setReportUrls] = useState<any>([])
  const [columnHeaders, setColumnHeaders] = useState<any>([])
  const [columnHeadersDispalyNames, setColumnHeadersDisplayNames] =
    useState<any>([])
  const [additionalTests, setAdditionalTests] = useState<any>({})
  const [maxHeightCalculated, setMaxHeightsetMaxHeight] = useState<any>({})
  const [testTile, setTestTile] = useState<any>(response && response)
  const [deleteToast, toggleDeleteToast] = useState<any>()
  const [saveToast, toggleSaveToast] = useState<any>()
  const [duplicateToast, toggleDuplicateToast] = useState<any>()
  const [finalSaveToast, toggleFinalSaveToast] = useState<any>()
  const [toastButtonSaveToast, toggleToastButtonSaveToast] = useState<any>()
  const [isEditing, setIsEditing] = useState<any>(false)


  const testNameItem = { key: "", unit: "", oldKey: '', oldUnit: '', oldestKey: '' }

  const initalFunction = () => {
    let rowHeaders1: any = [];
    let rowHeadersDate: any = [];
    let rowHeaders2: any = {};
    let reports: any = [];
    let additional: any = { keys: [], testResultsList: [] };

    response?.testResultsList?.forEach((obj: any, objIndex: any) => {
      rowHeaders1.push(obj?.title);
      rowHeadersDate.push(
        moment(obj?.appointmentDate)?.format("DD-MM-YYYY")
          ? moment(obj?.appointmentDate)?.format("DD-MM-YYYY")
          : ""
      );
      additional?.testResultsList?.push({ appointmentId: obj?.appointmentId });
      const objKeys = Object.keys(obj);
      let eachKeys: any = [];

      objKeys?.forEach((key: any) => {
        if (
          key !== "appointmentId" &&
          key !== "id" &&
          key !== "patientId" &&
          key !== "appointmentDate" &&
          key !== "title"
        ) {
          if (key !== "vitals") {
            additional.testResultsList[objIndex]["testResults"] = {};
            if (
              Object.keys(response["testResultsList"][objIndex]["testResults"])
                .length > 0
            ) {
              const tempKeys = Object.keys(
                response["testResultsList"][objIndex]["testResults"]
              );
              tempKeys?.forEach((eachKey: any) => {
                additional.testResultsList[objIndex]["testResults"][
                  `${eachKey}`
                ] = {};
                const keyNames = Object.keys(
                  response?.testResultsList[objIndex]["testResults"][
                  `${eachKey}`
                  ]
                );
                if (keyNames?.includes("reportUrl")) {
                  const filename = response?.testResultsList[objIndex][
                    "testResults"
                  ][`${eachKey}`]["reportUrl"]?.substring(
                    response?.testResultsList[objIndex]["testResults"][
                      `${eachKey}`
                    ]["reportUrl"]?.lastIndexOf("/") + 1
                  );
                  // Create a new report object for each report URL
                  reports[objIndex] = reports[objIndex] || [];
                  reports[objIndex].push({
                    name: `${filename ? filename : `${eachKey}.pdf`}`,
                    blobUrl:
                      response?.testResultsList[objIndex]["testResults"][
                      `${eachKey}`
                      ]["reportUrl"],
                  });
                } else {
                  // If there's no reportUrl, create a report object like the "vitals" case
                  reports[objIndex] = reports[objIndex] || [];
                  reports[objIndex].push({ name: "vitals", blobUrl: "" });
                }
              });
              tempKeys.unshift(response?.testResultsList?.[objIndex]?.appointmentDate);
              eachKeys = tempKeys;
            }
          } else {
            additional.testResultsList[objIndex]["vitals"] = {};
            eachKeys.push(response?.testResultsList?.[objIndex]?.appointmentDate);
            // Create a new report object for the vitals
            reports[objIndex] = reports[objIndex] || [];
            reports[objIndex].push({ name: "vitals", blobUrl: "" });
          }
        }
      });
      rowHeaders2[`${objIndex}`] = eachKeys;
    });

    const keyNamesList = Object.keys(vitalNames);
    const testsDisplayNames = response?.testNames?.map((t: any) => {
      if (keyNamesList?.includes(t)) {
        return vitalNames[t];
      } else {
        return t;
      }
    });

    setTopRowHeaders(rowHeaders1);
    setTopRowDates(rowHeadersDate);
    setBottomRowHeadersMap(rowHeaders2);
    setColumnHeaders(response?.testNames);
    setColumnHeadersDisplayNames(testsDisplayNames);
    setAdditionalTests(additional);
    setReportUrls(reports);
    setTestTile(response);
  };



  const findMaxHeight = () => {
    if (!tableRef?.current) return

    const trs: any = tableRef?.current?.querySelectorAll("tr")
    let maxHeightMap: any = {}

    trs?.forEach((tr: any, rowIndex: any) => {
      const tds: any = tr.querySelectorAll("td")
      tds?.forEach((td: any, columnIndex: any) => {
        const tdHeight: any = td?.clientHeight
        const temp = { ...maxHeightMap }
        if (!temp[rowIndex]) {
          temp[rowIndex] = {}
          temp[rowIndex][columnIndex] = tdHeight
        } else {
          temp[rowIndex][columnIndex] = tdHeight
        }
        maxHeightMap = { ...temp }
      })
    })
    const final: any = getIndividualMaxHeights(maxHeightMap)
    setMaxHeightsetMaxHeight(final)
    trs?.forEach((tr: any) => {
      const tds: any = tr.querySelectorAll("td")
      const ths: any = tableRef?.current?.querySelectorAll("th")
      tds.forEach((td: any, columnIndex: any) => {
        td.style.height = final[columnIndex] + "px"
      })
      ths.forEach((th: any, columnIndex: any) => {
        th.style.height = final[columnIndex] + "px"
      })
    })
  }

  function getIndividualMaxHeights(data: any) {
    const maxHeights: any = {}
    if (Object.keys(data)?.length > 0) {
      for (let i = 0; i < Object.keys(data[0])?.length; i++) {
        maxHeights[i] = Math.max(
          ...Object.values(data)?.map((obj: any) => obj[i])
        )
      }
    }
    return maxHeights
  }

  useEffect(() => {
    initalFunction()
  }, [response])

  useEffect(() => {
    findMaxHeight()
  }, [response, tableRef, topRowHeaders, topRowDates, bottomRowHeadersMap, columnHeaders, additionalTests, reportUrls])

  const handleAddNewTest = () => {
    if (isEditing) {
      toggleSaveToast({
        message: "Please save updated test values to proceed",
        type: "warning"
      })
    } else {
      const values = { ...additionalTests }
      values?.keys?.push(testNameItem)
      values?.testResultsList?.forEach((obj: any, objIndex: any) => {
        const objKeys = Object.keys(obj)
        objKeys?.forEach((key: any) => {
          if (
            key !== "appointmentId" &&
            key !== "id" &&
            key !== "patientId" &&
            key !== "appointmentDate" &&
            key !== "title"
          ) {
            if (key !== "vitals") {
              if (
                Object.keys(values["testResultsList"][objIndex]["testResults"])
                  .length > 0
              ) {
                const tempResults = Object.keys(
                  values["testResultsList"][objIndex]["testResults"]
                )
                tempResults?.forEach((tempResult: any) => {
                  const tempKeys = Object.keys(
                    values["testResultsList"][objIndex]["testResults"][tempResult]
                  )
                  tempKeys?.forEach((tempKey: any) => {
                    values?.keys?.forEach((eachKey: any, keyIndex: any) => {
                      values.testResultsList[objIndex]["testResults"][tempResult][tempKey] = {
                        ...values.testResultsList[objIndex]["testResults"][tempResult][tempKey],
                        [keyIndex]: "",
                      }
                    })
                  })
                })
              }
            } else {
              values?.keys?.forEach((eachKey: any, keyIndex: any) => {
                values.testResultsList[objIndex]["vitals"] = {
                  ...values.testResultsList[objIndex]["vitals"],
                  [keyIndex]: "",
                }
              })
            }
          }
        })
      })
      setAdditionalTests(values)
    }
  }

  const updateAdditionalTests = (additionalTest: any) => {
    const values = { ...additionalTest }
    values?.testResultsList?.forEach((obj: any, objIndex: any) => {
      const objKeys = Object.keys(obj)
      objKeys?.forEach((key: any) => {
        if (
          key !== "appointmentId" &&
          key !== "id" &&
          key !== "patientId" &&
          key !== "appointmentDate" &&
          key !== "title"
        ) {
          if (key !== "vitals") {
            if (
              Object.keys(values["testResultsList"][objIndex]["testResults"])
                .length > 0
            ) {
              const tempresults = Object.keys(
                values["testResultsList"][objIndex]["testResults"]
              )
              tempresults?.forEach((tempresult: any) => {
                const tempKeys = Object.keys(
                  values["testResultsList"][objIndex]["testResults"][tempresult]
                )
                tempKeys?.forEach((tempKey: any) => {
                  values?.keys?.forEach((eachKey: any, keyIndex: any) => {
                    if (eachKey?.oldKey !== '') {
                      if (eachKey?.key === '') {

                        values.testResultsList[objIndex]["testResults"][tempresult] = {
                          ...values.testResultsList[objIndex]["testResults"][tempresult],
                          "nullish": values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey],
                        }

                        delete values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey];

                      } else if (eachKey?.oldKey !== eachKey?.key) {

                        values.testResultsList[objIndex]["testResults"][tempresult] = {
                          ...values.testResultsList[objIndex]["testResults"][tempresult],
                          [eachKey?.key]: values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey],
                        }

                        delete values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey];

                      } else if (eachKey?.oldKey === "nullish") {
                        values.testResultsList[objIndex]["testResults"][tempresult] = {
                          ...values.testResultsList[objIndex]["testResults"][tempresult],
                          [eachKey?.key]: values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey],
                        }

                        delete values.testResultsList[objIndex]["testResults"][tempresult][eachKey?.oldKey];

                      } else {
                        delete values.testResultsList[objIndex]["testResults"][tempresult][
                          tempKey
                        ][keyIndex]
                        if (
                          Object.keys(
                            values.testResultsList[objIndex]["testResults"][tempresult][tempKey]
                          )?.length > 0
                        ) {
                        } else {
                          values.testResultsList[objIndex]["testResults"][tempresult][tempKey] = {
                            ...values.testResultsList[objIndex]["testResults"][tempresult][
                            tempKey
                            ],
                            [eachKey?.key]: {
                              value: "",
                              unit: "",
                            },
                          }
                        }
                      }
                    } else {
                      delete values.testResultsList[objIndex]["testResults"][tempresult][
                        tempKey
                      ][keyIndex]
                      if (
                        Object.keys(
                          values.testResultsList[objIndex]["testResults"][tempresult][tempKey]
                        )?.length > 0
                      ) {
                      } else {
                        values.testResultsList[objIndex]["testResults"][tempresult][tempKey] = {
                          ...values.testResultsList[objIndex]["testResults"][tempresult][
                          tempKey
                          ],
                          [eachKey?.key]: {
                            value: "",
                            unit: "",
                          },
                        }
                      }
                    }

                  })
                })
              })
            }

          } else {
            values?.keys?.forEach((eachKey: any, keyIndex: any) => {
              if (eachKey?.oldKey !== '') {
                if (eachKey?.key === '') {

                  values.testResultsList[objIndex]["vitals"] = {
                    ...values.testResultsList[objIndex]["vitals"],
                    "nullish": values.testResultsList[objIndex]["vitals"][eachKey?.oldKey],
                  }

                  delete values.testResultsList[objIndex]["vitals"][eachKey?.oldKey];

                } else if (eachKey?.oldKey !== eachKey?.key) {
                  values.testResultsList[objIndex]["vitals"] = {
                    ...values.testResultsList[objIndex]["vitals"],
                    [eachKey?.key]: values.testResultsList[objIndex]["vitals"][eachKey?.oldKey],
                  }

                  delete values.testResultsList[objIndex]["vitals"][eachKey?.oldKey];

                } else if (eachKey?.oldKey === "nullish") {
                  values.testResultsList[objIndex]["vitals"] = {
                    ...values.testResultsList[objIndex]["vitals"],
                    [eachKey?.key]: values.testResultsList[objIndex]["vitals"][eachKey?.oldKey],
                  }

                  delete values.testResultsList[objIndex]["vitals"][eachKey?.oldKey];

                } else {
                  {
                    delete values.testResultsList[objIndex]["vitals"][keyIndex]
                    if (
                      Object.keys(values?.testResultsList[objIndex]["vitals"])
                        .length > 0
                    ) {
                    } else {
                      values.testResultsList[objIndex]["vitals"] = {
                        ...values.testResultsList[objIndex]["vitals"],
                        [eachKey?.key]: {
                          value: "",
                          unit: "",
                        },
                      }
                    }
                  }
                }
              } else {
                delete values.testResultsList[objIndex]["vitals"][keyIndex]
                if (
                  Object.keys(values?.testResultsList[objIndex]["vitals"])
                    .length > 0
                ) {
                } else {
                  values.testResultsList[objIndex]["vitals"] = {
                    ...values.testResultsList[objIndex]["vitals"],
                    [eachKey?.key]: {
                      value: "",
                      unit: "",
                    },
                  }
                }
              }
            })

          }
        }
      })
    })

    values?.keys?.forEach((eachKey: any, keyIndex: any) => {
      if (eachKey?.oldKey === '') {
        values.keys[keyIndex] = {
          key: eachKey?.key,
          unit: eachKey?.unit,
          oldKey: eachKey?.key,
          oldUnit: eachKey?.oldUnit,
          oldestKey: eachKey?.oldestKey
        }
      } else if (eachKey?.key === '') {

        let isValuePresntArray: any = []

        values?.testResultsList?.forEach((obj: any, objIndex: any) => {
          const objKeys = Object.keys(obj);
          objKeys?.forEach((key: any) => {
            if (
              key !== "appointmentId" &&
              key !== "id" &&
              key !== "patientId" &&
              key !== "appointmentDate" &&
              key !== "title"
            ) {
              if (key === "vitals") {
                if (Object.keys(values["testResultsList"][objIndex]["vitals"]).length > 0) {
                  const tempKeys = Object.keys(values["testResultsList"][objIndex]["vitals"]);
                  if (!tempKeys?.includes("nullish")) {
                    isValuePresntArray.push(false)
                  } else {
                    tempKeys?.forEach((tempKey: any) => {
                      if (tempKey === "nullish" && values.testResultsList[objIndex]["vitals"]["nullish"]?.value !== '') {
                        if (values?.testResultsList?.[objIndex]?.["vitals"]?.["nullish"]?.value) {
                          isValuePresntArray.push(true)
                        }
                      } else if (tempKey === "nullish" && values?.testResultsList?.[objIndex]?.["vitals"]?.["nullish"]?.value === undefined) {
                        isValuePresntArray.push(false)
                      } else {
                        isValuePresntArray.push(false)
                      }
                    });
                  }
                }
              } else if (key === "testResults") {
                if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                  const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);
                  testResultTemp?.forEach((testTemp: any) => {
                    const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);
                    if (!tempKeys?.includes("nullish")) {
                      isValuePresntArray.push(false)
                    } else {
                      tempKeys?.forEach((tempKey: any) => {
                        if (tempKey === "nullish" && values?.testResultsList?.[objIndex]?.["testResults"]?.[testTemp]?.["nullish"]?.value !== '') {
                          if (values?.testResultsList?.[objIndex]?.["testResults"]?.[testTemp]?.["nullish"]?.value) {
                            isValuePresntArray.push(true)
                          }
                        } else if (tempKey === "nullish" && values?.testResultsList?.[objIndex]?.["testResults"]?.[testTemp]["nullish"]?.value === undefined) {
                          isValuePresntArray.push(false)
                        } else {
                          isValuePresntArray.push(false)
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        });


        if (isValuePresntArray?.includes(true)) {
          values.keys[keyIndex] = {
            key: eachKey?.key,
            unit: eachKey?.unit,
            oldKey: "nullish",
            oldUnit: eachKey?.oldUnit,
            oldestKey: eachKey?.oldestKey,
            disabled: true
          }
        } else {
          values.keys[keyIndex] = {
            key: eachKey?.key,
            unit: eachKey?.unit,
            oldKey: "nullish",
            oldUnit: eachKey?.oldUnit,
            oldestKey: eachKey?.oldestKey,
            disabled: false
          }
        }


      } else if (eachKey?.oldKey !== eachKey?.key || eachKey?.oldKey === "nullish") {
        values.keys[keyIndex] = {
          key: eachKey?.key,
          unit: eachKey?.unit,
          oldKey: eachKey?.key,
          oldUnit: eachKey?.oldUnit,
          oldestKey: eachKey?.oldestKey
        }
      }
    })
    setAdditionalTests(values)
  }

  const finalTestSave = (testArr: any, isDelete: any = false) => {
    const values = [...testArr?.testResultsList]
    const finalValues = values?.map((each: any, index: any) => {
      const valueItem = { ...each }
      Object.keys(valueItem)?.forEach((item: any) => {
        if (item === "vitals") {
          valueItem["vitals"] = {
            ...valueItem["vitals"],
            ...additionalTests?.testResultsList[index]["vitals"],
          }
        } else if (item === "testResults") {
          if (Object.keys(valueItem[item])?.length > 0) {
            Object.keys(valueItem[item])?.forEach((testItem: any) => {
              valueItem[item][testItem] = {
                ...valueItem[item][testItem],
                ...additionalTests?.testResultsList[index][item][testItem],
              }
            })
          }
        }
      })
      return valueItem
    })
    handleSaveTestResults(finalValues, isDelete)
  }

  const checkDuplicates = () => {
    const values = { ...additionalTests }
    let keysArray: any = []
    values?.keys?.map((viVal: any, viInd: any) => {
      if (viVal?.key !== '') {
        keysArray.push(viVal?.key)
      }
    });
    // Check for duplicates
    const duplicates = keysArray.filter((item: any, index: any) => keysArray.indexOf(item) !== index);

    return duplicates;
  }

  const handleSaveTests = (testArray: any, isDelete: any = false) => {
    const duplicatePresent = checkDuplicates();
    if (duplicatePresent?.length > 0) {
      toggleDuplicateToast({
        message: `Duplicate tests entered with name - ${duplicatePresent?.join(", ")}. \nDuplicates will be removed on save`,
        type: "warning"
      })
    } else {
      additionalValuesTest()
      setIsEditing(false)
      finalTestSave(testArray, isDelete)
    }
  }

  const handleSaveTestsWithDuplicated = (testArray: any, isDelete: any = false) => {
    additionalValuesTest()
    setIsEditing(false)
    finalTestSave(testArray, isDelete)
  }

  const deleteManuplation = (vitalVal: any) => {
    const values = { ...response }
    values?.testResultsList?.forEach((obj: any, objIndex: any) => {
      const objKeys = Object.keys(obj)
      objKeys?.forEach((key: any) => {
        if (
          key !== "appointmentId" &&
          key !== "id" &&
          key !== "patientId" &&
          key !== "appointmentDate" &&
          key !== "title"
        ) {
          if (key === "vitals") {
            if (
              Object.keys(values["testResultsList"][objIndex]["vitals"])
                .length > 0
            ) {
              const tempKeys = Object.keys(
                values["testResultsList"][objIndex]["vitals"]
              )
              tempKeys?.forEach((tempKey: any) => {
                if (tempKey === vitalVal) {

                  const temp = columnHeaders.filter((i: any) => i !== vitalVal)
                  setColumnHeaders(temp)
                  const temp1 = columnHeadersDispalyNames.filter((i: any) => i !== vitalVal)
                  setColumnHeadersDisplayNames(temp1)
                  delete values.testResultsList[objIndex]["vitals"][
                    tempKey
                  ]
                }
              })
            }
          } else if (key === "testResults") {

            if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
              const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);

              testResultTemp?.forEach((testTemp: any) => {
                const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);

                tempKeys?.forEach((tempKey: any) => {

                  if (tempKey === vitalVal) {

                    const temp = columnHeaders.filter((i: any) => i !== vitalVal);
                    setColumnHeaders(temp);

                    const temp1 = columnHeadersDispalyNames.filter((i: any) => i !== vitalVal);
                    setColumnHeadersDisplayNames(temp1);

                    delete values.testResultsList[objIndex]["testResults"][testTemp][tempKey];
                  }
                });
              });
            }
          }
        }
      })
    })
    return values
  }

  const deleteRow = (vitalValue: any) => {
    const values = deleteManuplation(vitalValue)
    setTestTile(values)
    handleSaveTests(values, true);
  }

  const checkValue = () => {
    const values = { ...additionalTests }
    let valuePresentAndTestName: any = []

    values?.keys?.map((viVal: any) => {
      let isValuePresntArray: any = []

      if (viVal?.key !== '') {
        values?.testResultsList?.forEach((obj: any, objIndex: any) => {
          const objKeys = Object.keys(obj);
          objKeys?.forEach((key: any) => {
            if (
              key !== "appointmentId" &&
              key !== "id" &&
              key !== "patientId" &&
              key !== "appointmentDate" &&
              key !== "title"
            ) {
              if (key === "vitals") {
                if (Object.keys(values["testResultsList"][objIndex]["vitals"]).length > 0) {
                  const tempKeys = Object.keys(values["testResultsList"][objIndex]["vitals"]);
                  if (!tempKeys?.includes(viVal?.key)) {
                    isValuePresntArray.push(false)
                  } else {
                    tempKeys?.forEach((tempKey: any) => {
                      if (tempKey === viVal?.key && values.testResultsList[objIndex]["vitals"][tempKey]?.value !== '') {
                        if (values?.testResultsList?.[objIndex]?.["vitals"]?.[tempKey]?.value) {
                          isValuePresntArray.push(true)
                        }
                      } else if (tempKey === viVal?.key && values?.testResultsList?.[objIndex]?.["vitals"]?.[tempKey]?.value === undefined) {
                        isValuePresntArray.push(false)
                      } else {
                        isValuePresntArray.push(false)
                      }
                    });
                  }
                }
              } else if (key === "testResults") {
                if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                  const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);
                  testResultTemp?.forEach((testTemp: any) => {
                    const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);
                    if (!tempKeys?.includes(viVal?.key)) {
                      isValuePresntArray.push(false)
                    } else {
                      tempKeys?.forEach((tempKey: any) => {
                        if (tempKey === viVal?.key && values.testResultsList[objIndex]["testResults"][testTemp][tempKey]?.value !== '') {
                          if (values?.testResultsList?.[objIndex]?.["testResults"]?.[testTemp]?.[tempKey]?.value) {
                            isValuePresntArray.push(true)
                          }
                        } else if (tempKey === viVal?.key && values?.testResultsList?.[objIndex]?.["testResuldts"]?.[testTemp]?.[tempKey]?.value === undefined) {
                          isValuePresntArray.push(false)
                        } else {
                          isValuePresntArray.push(false)
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        });
      }

      if (isValuePresntArray?.includes(true)) {
        valuePresentAndTestName.push({ valuePresent: true, testName: viVal?.key })
      } else {
        valuePresentAndTestName.push({ valuePresent: false, testName: viVal?.key })
      }

    });

    const trueExists = valuePresentAndTestName?.some((item: any) => item.valuePresent === true);
    const falseExists = valuePresentAndTestName?.some((item: any) => item.valuePresent === false);
    const testNameExists = valuePresentAndTestName?.some((item: any) => item.testName !== '');

    const testNamesArray = valuePresentAndTestName
      ?.filter((item: any) => item.valuePresent === false && item.testName !== '')
      .map((item: any) => item.testName);

    return { trueExists, falseExists, testNameExists, testNamesArray };
  };

  const checkExistingKey = () => {
    let existingTestNames: any = []
    const lowerTestNamesList: any = columnHeadersDispalyNames?.map((item: any) => item.toLowerCase());
    const values = { ...additionalTests }
    values?.keys?.map((viVal: any) => {
      if (lowerTestNamesList?.includes(viVal?.key?.toLowerCase())) {
        existingTestNames.push(viVal?.key)
      }
    })
    return existingTestNames;
  }


  const additionalValuesTest = () => {
    let existingTestNames: any = []
    if (!isEditing) {
      existingTestNames = checkExistingKey()
    }
    const values = { ...additionalTests }
    values?.keys?.map((viVal: any, viInd: any) => {
      let isValuePresntArray: any = []
      if (viVal?.key !== '') {
        values?.testResultsList?.forEach((obj: any, objIndex: any) => {
          const objKeys = Object.keys(obj);
          objKeys?.forEach((key: any) => {
            if (
              key !== "appointmentId" &&
              key !== "id" &&
              key !== "patientId" &&
              key !== "appointmentDate" &&
              key !== "title"
            ) {
              if (key === "vitals") {
                if (Object.keys(values["testResultsList"][objIndex]["vitals"]).length > 0) {
                  const tempKeys = Object.keys(values["testResultsList"][objIndex]["vitals"]);
                  if (!tempKeys?.includes(viVal?.key)) {
                    isValuePresntArray.push(false)
                  } else {
                    tempKeys?.forEach((tempKey: any) => {
                      if (tempKey === viVal?.key && values.testResultsList[objIndex]["vitals"][tempKey]?.value !== '') {
                        if (values?.testResultsList?.[objIndex]?.["vitals"]?.[tempKey]?.value) {
                          isValuePresntArray.push(true)
                        }
                      } else if (tempKey === viVal?.key && values?.testResultsList?.[objIndex]?.["vitals"]?.[tempKey]?.value === undefined) {
                        isValuePresntArray.push(false)
                      } else {
                        isValuePresntArray.push(false)
                      }
                    });
                  }
                }
              } else if (key === "testResults") {
                if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                  const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);
                  testResultTemp?.forEach((testTemp: any) => {
                    const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);
                    if (!tempKeys?.includes(viVal?.key)) {
                      isValuePresntArray.push(false)
                    } else {
                      tempKeys?.forEach((tempKey: any) => {
                        if (tempKey === viVal?.key && values.testResultsList[objIndex]["testResults"][testTemp][tempKey]?.value !== '') {
                          if (values?.testResultsList?.[objIndex]?.["testResults"]?.[testTemp]?.[tempKey]?.value) {
                            isValuePresntArray.push(true)
                          }
                        } else if (tempKey === viVal?.key && values?.testResultsList?.[objIndex]?.["testResuldts"]?.[testTemp]?.[tempKey]?.value === undefined) {
                          isValuePresntArray.push(false)
                        } else {
                          isValuePresntArray.push(false)
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        });
      } else {
        values?.testResultsList?.forEach((obj: any, objIndex: any) => {
          const objKeys = Object.keys(obj)
          objKeys?.forEach((key: any) => {
            if (
              key !== "appointmentId" &&
              key !== "id" &&
              key !== "patientId" &&
              key !== "appointmentDate" &&
              key !== "title"
            ) {
              if (key === "vitals") {
                delete values.testResultsList[objIndex]["vitals"][
                  "nullish"
                ]
                if (
                  Object.keys(values["testResultsList"][objIndex]["vitals"])
                    .length > 0
                ) {
                  const tempKeys = Object.keys(
                    values["testResultsList"][objIndex]["vitals"]
                  )
                  tempKeys?.forEach((tempKey: any) => {
                    if (!isNaN(tempKey)) {
                      delete values.testResultsList[objIndex]["vitals"][
                        tempKey
                      ]
                    }
                  })
                }
              } else if (key === "testResults") {
                if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                  const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);

                  testResultTemp?.forEach((testTemp: any) => {
                    const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);

                    delete values.testResultsList[objIndex]["testResults"][testTemp]["nullish"];

                    tempKeys?.forEach((tempKey: any) => {

                      if (!isNaN(tempKey)) {
                        delete values.testResultsList[objIndex]["testResults"][testTemp][tempKey];
                      }
                    });
                  });
                }
              }
            }
          })
        })
      }
      if (!isValuePresntArray?.includes(true)) {
        values?.testResultsList?.forEach((obj: any, objIndex: any) => {
          const objKeys = Object.keys(obj)
          objKeys?.forEach((key: any) => {
            if (
              key !== "appointmentId" &&
              key !== "id" &&
              key !== "patientId" &&
              key !== "appointmentDate" &&
              key !== "title"
            ) {
              if (key === "vitals") {
                if (
                  Object.keys(values["testResultsList"][objIndex]["vitals"])
                    .length > 0
                ) {
                  const tempKeys = Object.keys(
                    values["testResultsList"][objIndex]["vitals"]
                  )
                  tempKeys?.forEach((tempKey: any) => {
                    if (tempKey === viVal?.key) {
                      delete values.testResultsList[objIndex]["vitals"][
                        tempKey
                      ]
                    }
                  })
                }
              } else if (key === "testResults") {

                if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                  const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);

                  testResultTemp?.forEach((testTemp: any) => {
                    const tempKeys = Object.keys(values["testResultsList"][objIndex]["testResults"][testTemp]);

                    tempKeys?.forEach((tempKey: any) => {

                      if (tempKey === viVal?.key) {
                        delete values.testResultsList[objIndex]["testResults"][testTemp][tempKey];
                      }
                    });
                  });
                }
              }
            }
          })
        })
        deleteManuplation(viVal?.key)
      }
    })

    if (existingTestNames && existingTestNames?.length > 0) {
      values?.testResultsList?.forEach((obj: any, objIndex: any) => {
        const objKeys = Object.keys(obj)
        objKeys?.forEach((key: any) => {
          if (
            key !== "appointmentId" &&
            key !== "id" &&
            key !== "patientId" &&
            key !== "appointmentDate" &&
            key !== "title"
          ) {
            if (key === "vitals") {
              existingTestNames?.map((itemTest: any) => {
                delete values.testResultsList[objIndex]["vitals"][
                  itemTest
                ]
              })
            } else if (key === "testResults") {

              if (Object.keys(values["testResultsList"][objIndex]["testResults"]).length > 0) {
                const testResultTemp = Object.keys(values["testResultsList"][objIndex]["testResults"]);

                testResultTemp?.forEach((testTemp: any) => {
                  existingTestNames?.map((itemTest: any) => {
                    delete values.testResultsList[objIndex]["testResults"][testTemp][itemTest];
                  })
                });
              }
            }
          }
        })
      })
    }

    values?.keys?.map((viVal: any) => {
      if (viVal?.oldKey === "nullish") {
        if (viVal?.oldestKey !== '') {
          deleteManuplation(viVal?.oldestKey)
        }
      }
      if (viVal?.key !== viVal?.oldestKey) {
        if (viVal?.oldestKey !== '') {
          deleteManuplation(viVal?.oldestKey)
        }
      }
    })
    setAdditionalTests(values)
  }

  const editRow = (vitalValue: any) => {
    if (additionalTests?.keys?.length > 0) {
      toggleSaveToast({
        message: "Please save updated test values to proceed",
        type: "warning"
      })
    } else {
      setIsEditing(true)
      const values = { ...additionalTests }
      let unitTemp: any = ""
      response?.testResultsList?.forEach((res: any, resIndex: any) => {
        const trueValue: any = Object.keys(res?.testResults || {})
          ?.map((testTemp: any) => res?.testResults?.[testTemp]?.[vitalValue]?.unit)
          ?.filter((value: any) => value !== null && value !== undefined);

        if (trueValue?.length > 0) {
          unitTemp = trueValue[0]
          return;
        } else {
          const tempUnit = res?.vitals?.[vitalValue]?.unit ? res?.vitals?.[vitalValue]?.unit : "";
          if (tempUnit !== "") {
            unitTemp = tempUnit
          }
        }
      });
      values?.keys?.push({ key: vitalValue, unit: unitTemp, oldKey: vitalValue, oldUnit: unitTemp, oldestKey: vitalValue })
      values?.testResultsList?.forEach((obj: any, objIndex: any) => {
        const objKeys = Object.keys(obj)
        objKeys?.forEach((key: any) => {
          if (
            key !== "appointmentId" &&
            key !== "id" &&
            key !== "patientId" &&
            key !== "appointmentDate" &&
            key !== "title"
          ) {
            if (key !== "vitals") {
              if (
                Object.keys(values["testResultsList"][objIndex]["testResults"])
                  .length > 0
              ) {
                const testResultTemp = Object.keys(
                  values["testResultsList"][objIndex]["testResults"]
                )

                testResultTemp?.forEach((testTemp: any) => {
                  values.testResultsList[objIndex]["testResults"][testTemp] = {
                    ...values.testResultsList[objIndex]["testResults"][testTemp],
                    [vitalValue]: { value: response.testResultsList[objIndex]["testResults"][testTemp][vitalValue]?.value, unit: response.testResultsList[objIndex]["testResults"][testTemp][vitalValue]?.unit, flag: response.testResultsList[objIndex]["testResults"][testTemp][vitalValue]?.flag }
                  }
                })
              }
            } else {
              values?.keys?.forEach((eachKey: any, keyIndex: any) => {
                values.testResultsList[objIndex]["vitals"] = {
                  ...values.testResultsList[objIndex]["vitals"],
                  [vitalValue]: { value: response.testResultsList[objIndex]["vitals"][vitalValue]?.value, unit: response.testResultsList[objIndex]["vitals"][vitalValue]?.unit, flag: response.testResultsList[objIndex]["vitals"][vitalValue]?.flag },
                }
              })
            }
          }
        })
      })
      setAdditionalTests(values)

      // const val = deleteManuplation(vitalValue)
      // setTestTile(val)
    }
  }

  function scroll() {
    const element = document.getElementById('additionalVitalAdd');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <div>
      {deleteToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={deleteToast?.message}
            onClose={() => {
              toggleDeleteToast(false)
            }}
            onClick={() => {
              deleteRow(deleteToast?.value?.item);
              toggleDeleteToast(false);
            }}
            onCloseText="No"
            onClickText="Yes"
            type={deleteToast?.type}
          /></>
      )}
      {saveToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}></div>
          <Toast
            textMessage={saveToast?.message}
            onClose={() => {
              toggleSaveToast(false)
            }}
            onClick={() => {
              toggleSaveToast(false);
              const { trueExists, falseExists, testNameExists, testNamesArray } = checkValue()

              let existingTestNames: any = []
              if (!isEditing) {
                existingTestNames = checkExistingKey()
              }

              if (!falseExists && existingTestNames?.length === 0) {
                handleSaveTests(testTile)
              } else if (!trueExists && falseExists && !testNameExists && existingTestNames?.length === 0) {
                toggleFinalSaveToast({
                  message: `Test name not entered`,
                  type: "warning"
                })
              } else if (!trueExists && falseExists && existingTestNames?.length === 0) {
                toggleFinalSaveToast({
                  message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered`,
                  type: "warning"
                })
              } else if (!trueExists && falseExists && existingTestNames?.length > 0) {
                toggleFinalSaveToast({
                  message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered. \n${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} already exists`,
                  type: "warning"
                })
              } else if (!trueExists && !falseExists && existingTestNames?.length > 0) {
                toggleFinalSaveToast({
                  message: `${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} already exists`,
                  type: "warning"
                })
              } else if (trueExists && falseExists && existingTestNames?.length > 0) {
                toggleToastButtonSaveToast({
                  message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered. \n${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} will not be saved as ${existingTestNames && existingTestNames?.length === 1 ? 'it' : 'they'} already exists, \nclick on save to continue`,
                  type: "warning"
                })
              } else if (trueExists && !falseExists && existingTestNames?.length > 0) {
                toggleToastButtonSaveToast({
                  message: `${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} will not be saved as ${existingTestNames && existingTestNames?.length === 1 ? 'it' : 'they'} already exists, \nclick on save to continue`,
                  type: "warning"
                })
              } else {
                toggleToastButtonSaveToast({
                  message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered, \nclick on save to continue`,
                  type: "warning"
                })
              }
            }}
            onCloseText="Close"
            onClickText="Save"
            type={saveToast?.type}
          /></>
      )}
      {duplicateToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}></div>
          <Toast
            textMessage={duplicateToast?.message}
            onClose={() => {
              toggleDuplicateToast(false)
            }}
            onClick={() => {
              toggleDuplicateToast(false)
              handleSaveTestsWithDuplicated(testTile)
            }}
            onCloseText="Close"
            onClickText="Save"
            type={duplicateToast?.type}
          /></>
      )}
      {finalSaveToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={finalSaveToast?.message}
            onClose={() => {
              toggleFinalSaveToast(false)
            }}
            onCloseText="Close"
            type={finalSaveToast?.type}
          />
        </>
      )}
      {toastButtonSaveToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={toastButtonSaveToast?.message}
            onClose={() => {
              toggleToastButtonSaveToast(false)
            }}
            onClick={() => {
              handleSaveTests(testTile)
              toggleFinalSaveToast(false);
            }}
            onCloseText="Close"
            onClickText="Save"
            type={toastButtonSaveToast?.type}
          />
        </>
      )}
      {response?.testResultsList?.length > 0 && (
        <div className="print-btn cursor-pointer">
          <Print
            componentRef={componentRef}
          />
        </div>
      )}

      {/* -------Table Starts----- */}
      {response?.testResultsList?.length === 0 ||
        Object.keys(response)?.length === 0 ? (
        <div>No results found</div>
      ) : (
        <div
          style={readOnly ? { cursor: "not-allowed" } : {}}
          className="rmo-tests-table-wrapper"
        >
          <table>
            {columnHeaders?.length > 0 && (
              <div className="test-names-header-section">
                <th className="tests-header-section">
                  <tr>
                    <td className="test-name-header" rowSpan={2}>
                      Test Name
                    </td>
                    <td>
                      <tr>
                        {topRowHeaders?.map((each: any, index: any) => {
                          return (
                            <td
                              title={`${each}`}
                              className="top-header-section"
                              style={{
                                width: `${bottomRowHeadersMap[`${index}`]?.length * 120
                                  }px`,
                              }}
                              colSpan={Number(
                                `${bottomRowHeadersMap[`${index}`]?.length}`
                              )}
                            >
                              {each}
                              <p>{topRowDates[index]}</p>
                            </td>
                          )
                        })}
                      </tr>
                      <tr>
                        {Object.keys(bottomRowHeadersMap)?.length > 0 &&
                          Object.keys(bottomRowHeadersMap)?.map((each: any) => {
                            return bottomRowHeadersMap[`${each}`]?.map(
                              (e: any) => {
                                return e?.startsWith("MOC") ? (
                                  <td
                                    title={e}
                                    className="bottom-header-section report-heading"
                                  >
                                    <span>{e}</span>
                                  </td>
                                ) : (
                                  <td
                                    title={`${moment(e)?.format("DD-MM-YYYY")}`}
                                    className="bottom-header-section"
                                  >
                                    <span>Vitals</span>
                                    {moment(e)?.format("DD-MM-YYYY")}
                                  </td>
                                )
                              }
                            )
                          })}
                      </tr>
                      <tr>
                        {reportUrls?.length > 0 &&
                          reportUrls?.map((each: any) => {
                            return (
                              each?.map((eachItem: any) => {
                                return eachItem?.name === "vitals" ? (
                                  <td className="download-test-report"></td>
                                ) : (
                                  <td className="download-test-report">
                                    <a onClick={() => fileUtils.downloadFile(eachItem)}>
                                      Download Report
                                    </a>
                                  </td>
                                )
                              })
                            )
                          })
                        }
                      </tr>
                    </td>
                  </tr>
                </th>
              </div>
            )}

            {response?.testResultsList?.length > 0 && (
              <table ref={tableRef} className="table-inner">
                <div className="rmo-table">
                  <>
                    {!readOnly ? (
                      <tr>
                        {columnHeaders?.map((item: any, index: any) => {
                          let flagRetrieved = false;

                          response?.testResultsList?.forEach((res: any, resIndex: any) => {
                            const trueValue: any = Object.keys(res?.testResults || {})
                              ?.map((testTemp: any) => res?.testResults?.[testTemp]?.[item]?.flag)
                              ?.includes(true);
                            const flag = res?.vitals?.[item]?.flag ? res?.vitals?.[item]?.flag : trueValue ? true : false;
                            if (flag) {
                              flagRetrieved = true;
                            }
                          });

                          if (flagRetrieved) {
                            return (
                              <td className="rmo-values edit-delete active-edit">
                                <img src="../../../assets/images/CRedit.svg" alt="edit-icon" onClick={() => { editRow(item); scroll() }} />
                                <img src="../../../assets/images/CRdelete.svg" alt="delete-icon" onClick={() => {
                                  toggleDeleteToast({
                                    message: `${item} test values will be deleted for all appointments, are you sure you want to delete?`,
                                    type: "warning",
                                    value: { item }
                                  })
                                }} />
                              </td>
                            );
                          } else {
                            return (
                              <td className="rmo-values edit-delete disabled-edit">
                                <img src="../../../assets/images/CRedit.svg" alt="edit-icon" />
                                <img src="../../../assets/images/CRdelete.svg" alt="delete-icon" />
                              </td>
                            );
                          }
                        })}

                      </tr>
                    ) : (
                      <tr>
                        {columnHeaders?.map((item: any, index: any) => {
                          return (
                            <td className="rmo-values edit-delete disabled-edit">
                              <img src="../../../assets/images/CRedit.svg" alt="edit-icon" />
                              <img src="../../../assets/images/CRdelete.svg" alt="delete-icon" />
                            </td>
                          );
                        })}
                      </tr>
                    )}
                    <div>
                      {columnHeadersDispalyNames?.map((item: any) => {
                        return <th className="rmo-label">{item}</th>
                      })}
                    </div>

                    {response?.testResultsList?.map(
                      (obj: any, objIndex: any) => {
                        return Object.keys(obj)?.map((ele: any) => {
                          if (ele === "vitals") {
                            return (
                              <tr className="rmo-values">
                                {columnHeaders?.map((each: any) => {
                                  return (
                                    <td>
                                      {response["testResultsList"][objIndex][
                                        `${ele}`
                                      ][`${each}`]?.value
                                        ? response["testResultsList"][objIndex][
                                          `${ele}`
                                        ][`${each}`]?.value
                                        : "-"}
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          } else if (
                            ele !== "appointmentId" &&
                            ele !== "id" &&
                            ele !== "patientId" &&
                            ele !== "appointmentDate" &&
                            ele !== "title"
                          ) {
                            if (
                              Object.keys(
                                response["testResultsList"][objIndex][`${ele}`]
                              )?.length > 0
                            ) {
                              return Object.keys(
                                response["testResultsList"][objIndex][`${ele}`]
                              )?.map((each: any, innerIndex: any) => {
                                return (
                                  <tr className="rmo-values">
                                    {columnHeaders?.map((header: any) => {
                                      return (
                                        <td>
                                          {response["testResultsList"][
                                            objIndex
                                          ][`${ele}`][`${each}`][`${header}`]
                                            ?.value
                                            ? response["testResultsList"][
                                              objIndex
                                            ][`${ele}`][`${each}`][
                                              `${header}`
                                            ]?.value
                                            : "-"}
                                        </td>
                                      )
                                    })}
                                  </tr>
                                )
                              })
                            }
                          }
                        })
                      }
                    )}
                  </>
                </div>
              </table>
            )}
          </table>
          <table id="additionalVitalAdd">
            {additionalTests?.keys?.length > 0 && (
              <table className="table-inner">
                <div className="rmo-table">
                  <>
                    <div>
                      {additionalTests?.keys?.map((item: any, keyValueIndex: any) => {

                        return (
                          <div style={{ display: "flex" }} key={keyValueIndex}>
                            <div style={{ width: "259px" }}>
                              <InputField
                                value={item?.key}
                                placeholder="Test Name"
                                handleChange={(e: any) => {
                                  const values = { ...additionalTests };
                                  values["keys"][keyValueIndex]["key"] = e?.target?.value;
                                  const keyExists = values["keys"]?.some((item: any, index: any) => index !== keyValueIndex && item.key === e?.target?.value);
                                  setAdditionalTests(values);
                                  if (keyExists) {
                                    return;
                                  } else {
                                    updateAdditionalTests(values);
                                  }
                                }}
                              />
                            </div>
                            <div style={{ width: "100px" }}>
                              <InputField
                                value={item?.unit}
                                placeholder="Unit"
                                handleChange={(e: any) => {
                                  const values = { ...additionalTests };
                                  values["keys"][keyValueIndex]["unit"] = e?.target?.value;
                                  const keyExists = values["keys"]?.some((item: any, index: any) => index !== keyValueIndex && item.key === values["keys"][keyValueIndex]["key"] && item.unit !== e?.target?.value);
                                  setAdditionalTests(values);
                                  if (keyExists) {
                                    return;
                                  } else {
                                    updateAdditionalTests(values);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {additionalTests?.testResultsList?.map(
                      (obj: any, objIndex: any) => {
                        return Object.keys(obj).map((ele: any) => {
                          if (ele === "vitals") {
                            return (
                              <tr className="rmo-values">
                                {additionalTests?.keys?.map(
                                  (each: any, keyIndex: any) => {
                                    return (
                                      <div style={{ width: "120px" }}>
                                        <InputField
                                          readOnly={additionalTests?.keys?.[keyIndex]?.key === '' && additionalTests?.keys?.[keyIndex]?.oldKey === "nullish" && additionalTests?.keys?.[keyIndex]?.disabled}
                                          value={
                                            additionalTests?.keys?.[keyIndex]?.key === '' ? additionalTests?.keys?.[keyIndex]?.oldKey === "nullish" ? additionalTests["testResultsList"][
                                              objIndex
                                            ][`${ele}`][each?.oldKey]?.value : '' : additionalTests["testResultsList"][
                                              objIndex
                                            ][`${ele}`][each?.key]?.value
                                          }
                                          placeholder="Value"
                                          handleChange={(e: any) => {
                                            const values = {
                                              ...additionalTests,
                                            }
                                            additionalTests["testResultsList"][
                                              objIndex
                                            ][`${ele}`][each?.key] = {
                                              value: e?.target?.value,
                                              unit: each?.unit,
                                              flag: true,
                                            }
                                            setAdditionalTests(values)
                                          }}
                                        />
                                      </div>
                                    )
                                  }
                                )}
                              </tr>
                            )
                          } else if (
                            ele !== "appointmentId" &&
                            ele !== "id" &&
                            ele !== "patientId" &&
                            ele !== "appointmentDate" &&
                            ele !== "title"
                          ) {
                            if (
                              Object.keys(
                                additionalTests["testResultsList"][objIndex][
                                `${ele}`
                                ]
                              )?.length > 0
                            ) {
                              return Object.keys(
                                additionalTests["testResultsList"][objIndex][
                                `${ele}`
                                ]
                              )?.map((each: any, innerIndex: any) => {
                                return (
                                  <tr className="rmo-values">
                                    {additionalTests?.keys?.map((item: any, keyIndex: any) => {
                                      return (
                                        <div style={{ width: "120px" }}>
                                          <InputField
                                            readOnly={additionalTests?.keys?.[keyIndex]?.key === '' && additionalTests?.keys?.[keyIndex]?.oldKey === "nullish" && additionalTests?.keys?.[keyIndex]?.disabled}
                                            value={
                                              additionalTests?.keys?.[keyIndex]?.key === '' ? additionalTests?.keys?.[keyIndex]?.oldKey === "nullish" ? additionalTests[
                                                "testResultsList"
                                              ][objIndex][`${ele}`][`${each}`][
                                                `${item?.oldKey}`
                                              ]?.value : '' : additionalTests[
                                                "testResultsList"
                                              ][objIndex][`${ele}`][`${each}`][
                                                `${item?.key}`
                                              ]?.value
                                            }
                                            placeholder="Value"
                                            handleChange={(e: any) => {
                                              const values = {
                                                ...additionalTests,
                                              }
                                              additionalTests[
                                                "testResultsList"
                                              ][objIndex][`${ele}`][`${each}`][
                                                `${item?.key}`
                                              ] = {
                                                value: e?.target?.value,
                                                unit: item?.unit,
                                                flag: true,
                                              }
                                              setAdditionalTests(values)
                                            }}
                                          />
                                        </div>
                                      )
                                    })}
                                  </tr>
                                )
                              })
                            }
                          }
                        })
                      }
                    )}
                  </>
                </div>
              </table>
            )}
          </table>
          {response?.testResultsList?.length > 0 && (
            <>
              <div className="add-new-test-name">
                {!readOnly && (
                  <Button
                    text="Add New Test"
                    disabled={readOnly}
                    onClick={handleAddNewTest}
                  ></Button>
                )}
              </div>
              <div className="save-tests">
                {!readOnly && (
                  <Button
                    text="Save"
                    disabled={readOnly}
                    onClick={() => {
                      const { trueExists, falseExists, testNameExists, testNamesArray } = checkValue()
                      let existingTestNames: any = []
                      if (!isEditing) {
                        existingTestNames = checkExistingKey()
                      }

                      if (!falseExists && existingTestNames?.length === 0) {
                        handleSaveTests(testTile)
                      } else if (!trueExists && falseExists && !testNameExists && existingTestNames?.length === 0) {
                        toggleFinalSaveToast({
                          message: `Test name not entered`,
                          type: "warning"
                        })
                      } else if (!trueExists && falseExists && existingTestNames?.length === 0) {
                        toggleFinalSaveToast({
                          message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered`,
                          type: "warning"
                        })
                      } else if (!trueExists && falseExists && existingTestNames?.length > 0) {
                        toggleFinalSaveToast({
                          message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered. \n${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} already exists`,
                          type: "warning"
                        })
                      } else if (!trueExists && !falseExists && existingTestNames?.length > 0) {
                        toggleFinalSaveToast({
                          message: `${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} already exists`,
                          type: "warning"
                        })
                      } else if (trueExists && falseExists && existingTestNames?.length > 0) {
                        toggleToastButtonSaveToast({
                          message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered. \n${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} will not be saved as ${existingTestNames && existingTestNames?.length === 1 ? 'it' : 'they'} already exists, \nclick on save to continue`,
                          type: "warning"
                        })
                      } else if (trueExists && !falseExists && existingTestNames?.length > 0) {
                        toggleToastButtonSaveToast({
                          message: `${existingTestNames && existingTestNames?.join(", ")} ${existingTestNames && existingTestNames?.length === 1 ? 'test' : 'tests'} will not be saved as ${existingTestNames && existingTestNames?.length === 1 ? 'it' : 'they'} already exists, \nclick on save to continue`,
                          type: "warning"
                        })
                      } else {
                        toggleToastButtonSaveToast({
                          message: `Values for the ${testNamesArray && testNamesArray?.join(", ")} ${testNamesArray && testNamesArray?.length === 1 ? 'test' : 'tests'} are not entered, \nclick on save to continue`,
                          type: "warning"
                        })
                      }
                    }}
                  ></Button>
                )}
              </div>
            </>
          )}
        </div>
      )}
      <PrintTestResults
        topRowDates={topRowDates}
        topRowHeaders={topRowHeaders}
        bottomRowHeadersMap={bottomRowHeadersMap}
        columnHeaders={columnHeaders}
        columnHeadersDispalyNames={columnHeadersDispalyNames}
        response={response}
        componentRef={componentRef}
        patientInfo={patientInfo}
        maxHeightCalculated={maxHeightCalculated}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDate}
      />
    </div>
  )
}

export default TestResults
